<template>
  <div id="app" >
    <header id="top-head"
      v-bind:class="{ open: isMenuOpen }">
      <div class="inner" v-if="this.$route.params.lang === 'ja'">
        <div id="mobile-head">
          <h1 class="logo" v-on:click="isMenuOpen = false"><router-link :to="{name:'Bunkazai', params:{category:'bunkazai'}}" >南知多町の文化財</router-link></h1>
          <div id="nav-toggle" v-on:click="isMenuOpen = !isMenuOpen">
            <div>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
        <nav id="global-nav">
          <ul>
            <li v-on:click="isMenuOpen = !isMenuOpen" @mouseenter="isWasenMenu = !isWasenMenu" @mouseleave="isWasenMenu = !isWasenMenu">
              <a href="https://minamichita-museum.com/wasen/index.html">和船文化</a>
            </li>
            <li v-on:click="isMenuOpen = !isMenuOpen"><a href="https://minamichita-museum.com/wasen/ship.html">船内について</a></li>
            <li v-on:click="isMenuOpen = !isMenuOpen"><a href="https://minamichita-museum.com/wasen/shiseki.html">町内に残る史跡</a></li>
            <li v-on:click="isMenuOpen = !isMenuOpen"><a href="https://minamichita-museum.com/wasen/document.html">古文書</a></li>
            <li v-on:click="isMenuOpen = !isMenuOpen"><router-link :to="{name:'KoukoDashi', params:{category:'kouko'}}">考古資料</router-link></li>
            <li v-on:click="isMenuOpen = !isMenuOpen"><router-link :to="{name:'KoukoDashi', params:{category:'dashi'}}">山車</router-link></li>
            <li v-on:click="isMenuOpen = !isMenuOpen"><router-link :to="{params: {lang:'en'}}">EN</router-link></li>
            <li><a href="http://www.town.minamichita.lg.jp/main/">南知多町HP</a></li>
          </ul>
        </nav>
      </div>
      <div class="wasen_menu" v-if="this.$route.params.lang === 'ja'" @mouseenter="isWasenMenu = true" @mouseleave="isWasenMenu = false" v-bind:class="{show: isWasenMenu}">
          <p><a href="https://minamichita-museum.com/wasen/ship.html">船内について</a></p>
          <p><a href="https://minamichita-museum.com/wasen/shiseki.html">町内に残る史跡</a></p>
          <p><a href="https://minamichita-museum.com/wasen/document.html">古文書</a></p>
      </div>

      <div class="inner" v-if="this.$route.params.lang === 'en'">
        <div id="mobile-head" class="en">
            <h1 class="logo" v-on:click="isMenuOpen = !isMenuOpen"><router-link :to="{name:'Bunkazai'}">Minamichita<br>Cultural <br class="br_999">Property</router-link></h1>
            <div id="nav-toggle" v-on:click="isMenuOpen = !isMenuOpen">
                <div>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
        <nav id="global-nav">
          <ul class="en">
            <li><a href="https://minamichita-museum.com/wasen/en/index.html" @mouseenter="isWasenMenu = !isWasenMenu" @mouseleave="isWasenMenu = !isWasenMenu">Japanese-style<br class="sp_block">ship culture</a></li>
            <li><a href="https://minamichita-museum.com/wasen/en/ship.html">Ship Cabins</a></li>
            <li><a href="https://minamichita-museum.com/wasen/en/shiseki.html">History That Survives in Minamichita</a></li>
            <li><a href="https://minamichita-museum.com/wasen/en/document.html">Historical Documents</a></li>
            <li v-on:click="isMenuOpen = !isMenuOpen"><router-link :to="{name:'KoukoDashi', params:{category:'kouko'}}">Archaeological Materials</router-link></li>
            <li v-on:click="isMenuOpen = !isMenuOpen"><router-link :to="{name:'KoukoDashi', params:{category:'dashi'}}">Festival Floats</router-link></li>
            <li v-on:click="isMenuOpen = !isMenuOpen"><router-link :to="{params: {lang:'ja'}}">JA</router-link></li>
            <li class="hp_en"><a href="http://www.town.minamichita.lg.jp/main/">Minamichita Town HP</a></li>
          </ul>
        </nav>
      </div>
      <div class="wasen_menu" v-if="this.$route.params.lang === 'en'" @mouseenter="isWasenMenu = true" @mouseleave="isWasenMenu = false" v-bind:class="{show: isWasenMenu}">
          <p><a href="https://minamichita-museum.com/wasen/en/ship.html">Ship Cabins</a></p>
          <p><a href="https://minamichita-museum.com/wasen/en/shiseki.html">History That Survives in Minamichita</a></p>
          <p><a href="https://minamichita-museum.com/wasen/en/document.html">Historical Documents</a></p>
      </div>
    </header>
    <!--
    2種類の経路でviewを使いまわしたときに、beforeUpdateでのデータセットがうまく動かなくなる
    その対策にkeyを使うとmountを呼ぶようになるのでmount時にデータセットすることで対応できる
    https://github.com/vuejs/vue-router/issues/779
    -->
    <router-view :key="$route.path"/>

    <!-- footer -->
    <footer>
      <div class="sitearea" v-if="this.$route.params.lang === 'ja'">
          <div class="fix">
              <div class="left">
                  <p>南知多町文化遺産保存活用実行委員会</p>
                  <p class="address">〒470-3412<br>愛知県知多郡南知多町大字豊浜字須佐ヶ丘5番地</p>
              </div>
              <div class="right">
                  <p><img src="image/logo_bunkacho.jpg" alt="文化庁"></p>
                  <p>平成30年度文化庁文化芸術振興費補助金<br class="br_sp">（文化遺産総合活用推進事業）</p>
              </div>
          </div>
          <div class="copy">Copyright &copy; Minamichita Town. All rights reserved.</div>
      </div>
      <div class="sitearea" v-else-if="this.$route.params.lang === 'en'">
          <div class="fix">
              <div class="left">
                  <p>Minamichita Town Cultural Heritage Preservation Utilization Committee</p>
                  <p class="address">Aza Susagaoka 5, Oaza Toyohama, Minamichita Town, Chita County, Aichi Pref. 470-3412</p>
              </div>
              <div class="right">
                  <p><img src="image/logo_bunkacho.jpg" alt="文化庁"></p>
                  <p>Cultural and Arts Promotion Expenses Subsidy in 2018</p>
              </div>
          </div>
          <div class="copy">Copyright &copy; Minamichita Town. All rights reserved.</div>
      </div>
  </footer>
  </div>
</template>

<style lang="less">
  @font-face {
    font-family: 'Utsukushi';
    src: url('~@/assets/fonts/Utsukushi.woff') format('truetype');
  }
  //mediaquery設定
  @screen-xs-max: 660px; //スマホ
  @screen-sm-max: 768px; //ipad
  @screen-lg-max: 1200px; //ブラウザサイズ1200px以下
  .screen-xs(@rules) {
      @media (max-width: @screen-xs-max) { @rules(); } 
  }
  .screen-sm(@rules) {
      @media (max-width: @screen-sm-max) { @rules(); }
  }
  .screen-lg(@rules) {
      @media (max-width: @screen-lg-max) { @rules(); }
  }
  //user agent stylesheetを上書き
  *{
    margin: 0;
    padding: 0;
  }

  #app {
    font-family: "Utsukushi", "Hiragino Kaku Gothic ProN","メイリオ", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  #app{ 
    overflow: hidden;
    //サイトの表示領域
    .sitearea {
      margin: 0 auto;
      width: 1200px;
      .screen-lg({
        width: 90%;
      });
    }
    //コンテンツの表示領域
    .contentarea{
      margin: 0 auto;
      width: 980px;
      .screen-lg({
        width: 90%;
      });
    }
    //clearfix
    .fix {
      zoom: 1;
    }
    .fix:before, .fix:after {
      content: "";
      display: table;
    }
    .fix:after {
      clear: both;
    }

    //左寄せ
    .t_left{
      text-align: left;
    }
    //スマホ時改行削除
    .sp_block{
      display: block;
      .screen-sm({
        display: none;
      });
    }

  /*------------------------------toggoleメニューの設定----------------------------*/
    /* header */
    #mobile-head{
      .screen-sm({
        margin: 0 auto;
        width: 90%;
        height: 55px;
        z-index: 999;
        position: relative;
      });
    }

    #top-head {
      margin: 0 auto;
      width: 100%;
      height: 90px;
      line-height: 1;
      z-index: 999;
      color: #000;
      text-decoration: none;
      border-bottom: 1px solid #CBCBCB;
      .screen-sm({
        height: 55px;
        top: 0;
        position: fixed;
        margin-top: 0;
        background: #fff;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.14);
      });
      a{
        color: #000;
        text-decoration: none;
      }
      .inner{
        margin: 0 auto;
        width: 1200px;
        height: 100%;
        position: relative;
        .screen-lg({
          width: 90%;
        });
        .screen-sm({
          width: 100%;
        });
        &:after {
          content: "";
          clear: both;
          display: block;
        }
      }
      .logo {
        margin-top: 34px;
        width: 35%;
        float: left;
        font-size: 28px;
        text-align: left;
        .screen-sm({
          margin-top: 18px;
          width: 100%;
          font-size: 24px;
        });
      }
      .wasen_menu{
        width: 100%;
        height: 0;
        top: 91px;
        background: #fff;
        position: absolute;
        overflow: hidden;
        transition-delay: 2s;
        transition-duration: .35s;
        z-index: 100;
        p{
          padding: 16px 50px 0;
          display: inline-block;
          font-size: 18px;
        }
      }
      .show{
        height: 50px;
        transition-delay: 0.5s;
        transition-duration: .2s;
        .screen-sm({
          height: 0;
        });
      }
    }
    #top-head .en{
      .logo {
        margin-top: 20px;
        @media (max-width: 999px) {
          margin-top: 10px;
          width: 24%;
          font-size: 24px;
        }
        .screen-sm({
          margin-top: 2px;
          width: 100%;
        });
      }
    }

    #global-nav{
      .screen-sm({
        position: absolute;
        /* 開いてないときは画面外に配置 */
        top: -501px;
        background: #fff;
        width: 100%;
        height: 425px;
        box-shadow: 0px 0px 6px rgba(0,0,0,0.5);
        text-align: center;
        -webkit-transition: .5s ease-in-out;
        -moz-transition: .5s ease-in-out;
        transition: .5s ease-in-out;
        z-index: 1000;
      });
      ul {
        list-style: none;
        position: absolute;
        width: 72%;
        height: 100%;
        right: 0;
        bottom: 0;
        font-size: 18px;
        overflow: hidden;
        .screen-sm({
          width: 100%;
          list-style: none;
          position: static;
          right: 0;
          bottom: 0;
          font-size: 14px;
        });
        li{
          float: left;
          .screen-sm({
            padding-top: 0;
            border-bottom: 1px solid #CBCBCB;
            float: none;
            position: static;
          });
          &:nth-of-type(1){
            padding-top: 38px;
            width: 17%;
            text-align: left;
            .screen-lg({
              margin-left: 10%;
            });
            .screen-sm({
              margin-top: 100px;
              margin-left: 0;
              padding-top: 0;
              padding-left: 5%;
              width: 100%;
              border-top: 1px solid #CBCBCB;
            });
          }
          &:nth-of-type(2),
          &:nth-of-type(3),
          &:nth-of-type(4){
            display: none;
            .screen-sm({
              padding-left: 15%;
              background: #E9EFF0;
              display: block;
              text-align: left;
              position: relative;
            });
            &:before{
              content: '';
              width: 5px;
              height: 5px;
              border: 0px;
              border-top: solid 0.5px #000;
              border-right: solid 0.5px #000;
              -ms-transform: rotate(45deg);
              -webkit-transform: rotate(45deg);
              transform: rotate(45deg);
              position: absolute;
              top: 45%;
              left: 7.5%;
            }
          }
          &:nth-of-type(5){
            padding-top: 38px;
            width: 17%;
            text-align: left;
            .screen-sm({
              padding-top: 0;
              padding-left: 5%;
              width: 100%;
            });
          }
          &:nth-of-type(6){
            padding-top: 38px;
            text-align: left;
            .screen-sm({
              padding-top: 0;
              padding-left: 5%;
            });
          }
          &:nth-of-type(7){
            width: 100px;
            height: 100%;
            background: #B9B5A7;
            float: right;
            text-align: center;
            a{
              margin: 0 auto;
              padding: 39px 0px;
              width: 100%;
              color: #fff;
              display: block;
              .screen-sm({
                padding: 23px 0px;
              });
            }
            .screen-lg({
              width: 80px;
            });
            .screen-sm({
              margin: 0 5%;
              width: 35%;
              height: 60px;
              top: 20px;
              right: 0;
              position: absolute;
            });
          }
          &:nth-of-type(8){
            width: 140px;
            height: 100%;
            background: #3F698F;
            float: right;
            text-align: center;
            a{
              margin: 0 auto;
              padding: 39px 0px;
              width: 100%;
              color: #fff;
              display: block;
              .screen-sm({
                padding: 21px 0px;
              });
            }
            .screen-lg({
              width: 120px;
            });
            .screen-sm({
              margin-left: 5%;
              width: 50%;
              height: 60px;
              top: 20px;
              position: absolute;
            });
          }
          a{
            .screen-sm({
              width: 100%;
              display: block;
              font-size: 18px;
              padding: 16px 0;
            });
            &.router-link-active {
              border-bottom: 2px solid #3F698F;
              margin-bottom: 2px;
              .screen-sm({
                border-bottom: 0;
                margin-bottom: 0;
              });
            }
          }
        }
      }
      ul.en{
        @media (max-width: 999px) {
          width: 80%;
        }
        .screen-sm({
          width: 100%;
        });
        li{
          &:nth-of-type(1){
            .screen-lg({
              margin-left: 0;
            });
            @media (max-width: 999px) {
              margin-left: 3%;
            }
            .screen-sm({
              margin-left: 0;
            });
          }
          &:nth-of-type(1),
          &:nth-of-type(5){
            width: 23%;
            padding-top: 20px;
            line-height: 1.5;
            @media (max-width: 999px) {
              padding-top: 25px;
            }
          }
          &:nth-of-type(1),
          &:nth-of-type(5),
          &:nth-of-type(6){
            @media (max-width: 999px) {
              width: 20%;
              font-size: 14px;
            }
            .screen-sm({
              padding-top: 0;
              width: 100%;
              line-height: 1;
            });
          }
        }
        
      }
      .hp_en{
        a{
          padding: 30px 0px !important;
        }
        .screen-sm({
          a{
            padding: 23px 0px !important;
          }
        });
        .screen-xs({
          a{
            font-size: 14px;
          }
        });
      }
    }
    /* Toggle Button */
    #nav-toggle {
      display: none;
      position: absolute;
      right: 0;
      top: 14px;
      width: 34px;
      height: 36px;
      cursor: pointer;
      z-index: 101;
      .screen-sm({
        display: block;
      });
      div {
        position: relative;
      }
      span {
        display: block;
        position: absolute;
        height: 2px;
        width: 100%;
        background: #666;
        left: 0;
        -webkit-transition: .35s ease-in-out;
        -moz-transition: .35s ease-in-out;
        transition: .35s ease-in-out;
        &:nth-child(1) {
          top: 2px;
        }
        &:nth-child(2) {
          top: 13px;
        }
        &:nth-child(3) {
          top: 24px;
        }
      }
    }
    /* #nav-toggle 切り替えアニメーション */
    .open{
      #nav-toggle{
        span{
          &:nth-child(1){
            .screen-sm({
              top: 11px;
              -webkit-transform: rotate(315deg);
              -moz-transform: rotate(315deg);
              transform: rotate(315deg);
            });
          }
          &:nth-child(2){
            .screen-sm({
              width: 0;
              left: 50%;
            });
          }
          &:nth-child(3){
            .screen-sm({
              top: 11px;
              -webkit-transform: rotate(-315deg);
              -moz-transform: rotate(-315deg);
              transform: rotate(-315deg);
            });
          }
        }
      }
      #global-nav {
        .screen-sm({
          -moz-transform: translateY(556px);
          -webkit-transform: translateY(556px);
          transform: translateY(556px);
        });
      }
    }
    /* footer */
    footer{
      background: #555555/*e4e4e4*/;
      color: #fff;
      padding: 18px 0 10px 0; 
      .left{
        width: 50%;
        float: left;
        .screen-xs({
          width: 100%;
          float: none;
        });
        p{
          margin-bottom: 7px;
          font-size: 18px;
          line-height: 1.5;
          text-align: left;
          .screen-xs({
            font-size: 16px;
            text-align: center;
          });
        }
        .address{
          margin-bottom: 15px !important;
          font-size: 18px;
          border: 0;
          text-align: left;
          .screen-xs({
            font-size: 12px;
            text-align: center;
          });
        }
      }
      .right{
        float: right;
        width: 50%;
        font-size: 12px;
        text-align: right;
        line-height: 1.5;
        margin-top: 45px;
        .screen-xs({
          width: 100%;
          float: none;
          font-size: 10px;
        });
        p{
          margin-bottom: 7px;
          line-height: 1.5;
          .screen-xs({
            text-align: center;
          });
        }
        img{
          width: 50px;
        }
      }
      .copy{
        margin-top: 10px;
        font-size: 12px;
        text-align: center;
        line-height: 1.7;
      }
    }
    .br_sp{
      .screen-xs({
        display: block;
      });
    }
    .br_999{
      display: none;
      @media (max-width: 999px) {
        display: block;
      }
      .screen-sm({
        display: none;
      });
    }
  }
</style>

<script>
  export default {
    name: 'App',
    data: function() {
        return{
          isMenuOpen:false,
          isWasenMenu:false
        }
    }
  }
</script>
